import React, { useState, useEffect } from 'react';
// import $ from jQuery
import { BaseUrl } from './BaseUrl';
import { AssetsUrl } from './BaseUrl';
import Slider from "react-slick";

export default function Conference_Centre() {
  const [baseUrl] = useState(BaseUrl);
  const [assetsUrl] = useState(AssetsUrl);
 
  const [relatedoc, setRelatedoc] = useState([]);
  const [banner_img , setbanner_img] = useState([])

  useEffect(() => {
    fetch(`${baseUrl}/getfilesbyid/8`)
      .then((resp) => resp.json())
      .then((result) => setRelatedoc(result))
      .catch((err) => console.error("Error fetching related docs:", err));

      // Fetch banner images
      fetch(`${baseUrl}/getBannerById/8`)
      .then((resp) => resp.json())
      .then((result) => { 
        setbanner_img(result.banner_images); 
      })
      .catch((err) => console.error("Error fetching banner images:", err));

}, []);

var settings = {
  className: "",
  dots: false,
  infinite: true,
  slidesToShow: 1,
  slidesToScroll: 1,
  adaptiveHeight: true,
  autoplay: true,
  speed: 1000,
  autoplaySpeed: 7000,
  pauseOnHover: false,
  cssEase: "linear",
  adaptiveHeight: true,
};

  return (
    <>
        <div className="container-fluid slider_top desktop_show">
          <div className="row">
            {banner_img.map((banner, i) => {
              return (
                <div className="col-lg-4 col-12">
                  <img src={`${assetsUrl}/uploads/${banner}`} alt="" className='bnr_img_30 padding_set' />
                </div>
              )
            })}
          </div>
        </div>

        <div className="slider_images mobile_view_Show">
                  <Slider {...settings}>
                    {banner_img.map((single_image) => {
                      return (
                        <div>
                          <img
                            src={`${assetsUrl}/uploads/${single_image}`}
                            className="bnr_img bnr_img_30"
                          />
                        </div>
                      );
                    })}
                  </Slider>
                </div>

        <section className="counter-section-03 py-2 mt-4" style={{padding:'0px 0px 40px 0px',backgroundColor: 'white'}}>
            <div className="container" > 
                <div className="row" >
                    <div className="col-md-12 mt-4" style={{color:'#000',fontSize:'16px'}}>
                    <div className="col-md-12 col-12">
                <ul>
                <li className="text_justify">Our Catering Department brings together culinary excellence and outstanding inspirational service to create the perfect catered event. It is our goal to provide fresh ingredients, local products and carefully crafted menus each and every day.</li>
                <li className="text_justify">Ready to reserve catering? Book now through <a href='https://openspace.gaiacloud.jpmchase.net/dashboard' target='_blank' className='top_heading2'>Go/Openspace</a ></li>
                <li className="text_justify">Let us help you make your culinary experience worth remembering! Click here for the  <a href='https://foodweb-macaw.ksoftpl.com/magma-backend/public/uploads/1675338294.pdf' target='_blank' className='top_heading2'>Catering Menu.</a ></li>
                </ul>
            </div>
                    </div>
                </div>
            </div>
        </section>

        <section className="counter-section-03 padding-top-50 padding-bottom-50 mt-4" style={{padding:'0px 0px 0px 0px',backgroundColor: 'white'}}>
            <div className="container">
                <div className="row">
                    <div className="col-md-12 mt-2" style={{color:'#000',fontSize:'16px'}}>
                    <div className="col-md-12 col-12">
           {/* <h4 className='top_heading_margin' style={{marginBottom: '10px'}}><span className='top_heading'>Ready to reserve catering? Book now through</span> <a href='https://openspace.gaiacloud.jpmchase.net/dashboard' target='_blank' className='top_heading2'>Go/Openspace</a ></h4>
           <h5 class="top_heading_margin"><span class="top_heading">Click here for the </span> <a href="https://foodweb-macaw.ksoftpl.com/magma-backend/public/uploads/1631308473.pdf" target="_blank" className="top_heading2" style={{fontSize: '15px'}}>Catering Menu</a></h5> */}
                <p className="table_heading ">Your Safety is Our Top Priority</p>
                <p className="table_content">We remain committed to the highest standard of food safety, hygiene and sanitation with rigorous hand washing, sanitizing surfaces, daily team health checks and promoting social distancing. We have made some modifications to our menu so that we may continue to keep everyone safe and healthy, including individually packaged meals and recommended safety protocols.</p>
                
            </div>

            <div className="col-md-12 col-12">
                <p className="table_heading ">We're Here to Help!</p>
                <ul>
                  <li className='table_content' style={{margin:'0px 0px 10px 0px'}}>Allergen information available</li>
                  <li className='table_content'>For any other inquiries, do not hesitate to contact your Amenity Services Team</li>
                </ul>
            </div>

                    </div>
                    
                </div>
            </div>
        </section>

        {
  relatedoc.length === 0 ? null : 
  <div className="row   bg-color  related_doc mt-4" style={{ paddingBottom: '100px' }}>
    <div className="container conference-related related-doc" >
     
      
      <h3 className="res-title conference-title" style={{ color: '#000', marginTop: '40px'}}>Related Document</h3>
    
      <div className="row mb-3 ">
        <div className="col-12 ">
          { relatedoc.map(doc => 
            <div className="col-lg-12 col-md-12 col-xs-12 col-sm-12 conference-link" key={doc.id}>
              <a href={`${assetsUrl}/uploads/${doc.file_name}`} target="_blank" rel="noopener noreferrer">
                <p className="des realtedoc">{doc.file_title}</p>
              </a>
            </div>
          )}
        </div>
      </div> 
    </div>
  </div>
}

         
    </>
  )
}
